import { PaymentMethodEnum } from '@aid/insurances/types/enums/payment-method.enum';

export class PaymentMethod {
  id?: number;
  name?: string;
  identifier?: PaymentMethodEnum;
}
